import   React           ,
       { useEffect       ,
         useState        ,
         useMemo         }  from "react";


import   styles             from "./Advertisement.module.scss";

import { QRCodeGenerator }  from "../../../components/widget/images/QRCodeGenerator";
import { Icon            }  from "../../../components/widget/images/Icon";
import { Product         ,
         initializedProduct }  from "../../../dataTypes/productManagment/types";
import { searchImage     }  from "../../../dataTypes/productManagment/utils";

import { WWW_URLS        }  from '../../../backendServices/urls';


const ProductImage: React.FC<{ src: string; name: string; size: number }> = React.memo ( ( { src, name, size } ) => (

    <div className = {styles.productImageWrapper}
         style     = {{ width: `${size}px`, height: `${size}px` }}  >
      <img src={src} alt={name} className={styles.productImage} />
    </div>
  )
);

const ProductQRCode: React.FC<{ url: string; size: number; onClick: () => void }> = React.memo( ( { url, size, onClick } ) => (

    <div className = {styles.qrCode}
         onClick   = {onClick}
         style     = {{ cursor: "pointer", marginBottom: "10px" }} >
      <QRCodeGenerator url={url} size={size} />
    </div>
  ),
  (prev, next) => prev.url === next.url && prev.size === next.size
);

/* ─────────────────────────────
   Sous-composant principal : Advertisement
───────────────────────────────*/
export interface AdvertisementProps {
  product?: Product | null;  // Rendre product optionnel
  selectedVariant?: number;
  selectedImage?: number;
  width: number;
  onlyQRcode?: boolean;
  comment1?: string;
  comment2?: string;
  shapeColor1?: string;
  shapeColor2?: string;
  backgroundColor1?: string;
  backgroundColor2?: string;
  redirectionUuid?: string;
  withImage?: boolean;
  alternateImage?: string | null;
}

export const Advertisement: React.FC<AdvertisementProps> = React.memo ( ( { product                                                ,
                                                                            selectedVariant  = 0                                   ,
                                                                            selectedImage    = 0                                   ,
                                                                            width                                                  ,
                                                                            onlyQRcode       = false                               ,
                                                                            comment1         = "Offre spéciale"                    ,
                                                                            comment2         = "Scannez le QR code pour commander" ,
                                                                            shapeColor1      = "#FFF"                              ,
                                                                            shapeColor2      = "#000"                              ,
                                                                            backgroundColor1 = "#000"                              ,
                                                                            backgroundColor2 = "#ebff40"                           ,
                                                                            redirectionUuid                                                    ,
																			withImage        = true                                ,
                                                                            alternateImage                                         } ) => {

    const editedProduct        = product ? product : initializedProduct()

    const name                 = editedProduct.name;
    const price                = editedProduct.variants?.[0]?.prices?.[0]?.priceWithTax || 0;
    const qrCodeCharacteristic = editedProduct.characteristics.find((char) => char.kind === "QRcode");
    const calculatedUrl        = qrCodeCharacteristic?.value ?? (
                                                                  editedProduct.code !== ''
                                                                  ?
                                                                  `${WWW_URLS.customer_front}/panier?product=${editedProduct.code}`
                                                                  :
                                                                  `${WWW_URLS.customer_front}`
                                                                );
    const finalUrl             = redirectionUuid ? `${WWW_URLS.customer_front}/partenaire?redirect=${redirectionUuid}` : calculatedUrl;
    const handleQrCodeClick    = () => { window.open(finalUrl, "_blank", "noopener,noreferrer"); };
    const baseWidth            = 320;
    const dynamicStyles        = useMemo ( () => ( { fontSize1: ( width / baseWidth ) *  40 ,
                                                     fontSize2: ( width / baseWidth ) *  32 ,
                                                     fontSize3: ( width / baseWidth ) *  28 ,
                                                     fontSize4: ( width / baseWidth ) *  32 ,
                                                     imageSize: ( width / baseWidth ) * 280 } ), [width] );

    const [ imgSrc , setImgSrc ] = useState<string|null>(alternateImage || "");

    useEffect(() => {


      let active = true;

      if (alternateImage)
            {
             setImgSrc(alternateImage);
            }
       else {
             searchImage ( editedProduct, selectedVariant, selectedImage ).then ( (image) => { if (active) {setImgSrc(image);} else {setImgSrc(null);} } );
            }

      return () => { active = false; };

    }, [editedProduct.id, selectedVariant, selectedImage, alternateImage]);

      console.log ('imgSrc', imgSrc)

    return (
             <div className={styles.root} style={{ width: `${width}px` }}>
               {
                !onlyQRcode &&
                (
                 <>

                  {/* Commentaire 1 */}
                  <div className = {styles.textWhiteOnBlack}
                       style                   = {{ fontSize:        `${dynamicStyles.fontSize1}px` ,
                                                    color:           shapeColor1                    ,
                                                    backgroundColor: backgroundColor1               }}
                       dangerouslySetInnerHTML = {{ __html:          comment1                       }} />

                  {/* Zone produit */}
                  <div className = {styles.productContainer}
                       style     = {{ fontSize:        `${dynamicStyles.fontSize2}px` ,
                                      color:           shapeColor2                    ,
                                      backgroundColor: backgroundColor2               }} >

                    {/* Commentaire 2 */}
                    <div className={styles.comment2}
                         style={{ fontSize: `${dynamicStyles.fontSize2}px` }}
                         dangerouslySetInnerHTML={{ __html: comment2 }} />

{/* Image produit */}
{
  withImage &&
  (					 
   imgSrc 
    ?
    (
      <ProductImage src  = {imgSrc}
                    name = {name}
                    size = {dynamicStyles.imageSize} />
    )
    :
    (
      <Icon name   = 'noPhoto'
            width  = {dynamicStyles.imageSize}
            height = {dynamicStyles.imageSize} />
    )
  )
}
                    {/* Nom et prix */}
              <div
                className={styles.productName}
                style={{
                  fontSize: `${dynamicStyles.fontSize3}px`,
                  fontWeight: "bold",
                }}
                dangerouslySetInnerHTML={{ __html: name }}
              />
              {price > 0 && (
                <div
                  className={styles.productPrice}
                  style={{
                    fontSize: `${dynamicStyles.fontSize4}px`,
                    fontWeight: "bold",
                  }}
                  dangerouslySetInnerHTML={{ __html: `${price.toFixed(2)} €` }}
                />
              )}

              {/* QR Code */}
              <ProductQRCode
                url={finalUrl}
                size={dynamicStyles.imageSize}
                onClick={handleQrCodeClick}
              />
            </div>
          </>
        )}

        {onlyQRcode && (
          <div
            className={styles.qrCodeOnly}
            style={{
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <ProductQRCode
              url={finalUrl}
              size={dynamicStyles.imageSize}
              onClick={handleQrCodeClick}
            />
          </div>
        )}
      </div>
    );
  },

  // 🧮 comparaison personnalisée pour éviter les re-rendus inutiles

  ( prev , next ) => { 
                       if (!prev.product && !next.product) return true;
                       if (!prev.product || !next.product) return false;
  
                       return ( prev.product.id       === next.product.id       &&
                                prev.selectedVariant  === next.selectedVariant  &&
                                prev.selectedImage    === next.selectedImage    &&
                                prev.width            === next.width            &&
                                prev.redirectionUuid  === next.redirectionUuid  &&
                                prev.withImage        === next.withImage        &&
                                prev.alternateImage   === next.alternateImage   &&
                                prev.onlyQRcode       === next.onlyQRcode       &&
                                prev.comment1         === next.comment1         &&
                                prev.comment2         === next.comment2         &&
                                prev.shapeColor1      === next.shapeColor1      &&
                                prev.shapeColor2      === next.shapeColor2      &&
                                prev.backgroundColor1 === next.backgroundColor1 &&
                                prev.backgroundColor2 === next.backgroundColor2 );
  }
);
